// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"fadae53a","570":"7dfc354b","598":"3f9dd809","947":"98387bdc"}[chunkId] + ".chunk.css";
};